/** @format */

import React from 'react';
import './styles.scss';
import MUIDataTable from 'mui-datatables';
import TableDataLoader from 'components/TableDataLoader';

export const DataTable = ({
  data,
  className,
  columns,
  options,
  title,
  loading = false
}) => {
  const Loader = () => {
    if (loading) {
      return (
        <div className='table-loader-container'>
          <TableDataLoader />
        </div>
      );
    }
  };
  return (
    <div
      className={`${className} fm-data-table-container ${
        loading && 'loading'
      }`}>
      <Loader />
      <div className='data-table'>
        <MUIDataTable
          title={title}
          data={data}
          columns={columns}
          options={options}
        />
      </div>
    </div>
  );
};
